import { createApp } from '@backstage/frontend-defaults';
import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { githubAuthApiRef } from '@backstage/core-plugin-api';
import { SignInPageBlueprint } from '@backstage/plugin-app-react';
import { SignInPage } from '@backstage/core-components';
import manager from '@rls/static-site-manager';
import { navModule } from './modules/nav';
const signInPage = SignInPageBlueprint.make({ params: { loader: async () => props => <SignInPage {...props} provider={{ id: 'github-auth-provider', title: 'GitHub', message: 'Sign in with your approved Red Letter Solutions GitHub account', apiRef: githubAuthApiRef }} /> } });
export default createApp({ features: [manager, navModule, createFrontendModule({ pluginId: 'app', extensions: [signInPage] })] });
